module.exports = __webpack_public_path__ + "img/crush_brown_natural_ba_list.57ee9c83.jpg";